import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { brandSecondary, label } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: `flex`,
		flex: 1,
		flexDirection: `column`,
		minHeight: 0,
	},
	title: {
		flexShrink: 0,
		marginBottom: THEME.spacing.md,
		textAlign: 'center',
	},
	popup: {
		height: '80vh',
		maxWidth: 640,
		width: '100%',
	},
	searchGroup: {
		flexShrink: 0,
		marginBottom: THEME.spacing.sm,
	},
	templateCard: {
		display: `flex`,
		flexDirection: `column`,
		gap: 8,
		boxSizing: `border-box`,
		padding: 12,
		position: 'relative',
		borderRadius: 6,
		boxShadow: 'oklab(0 0 0 / 0.1) 0px 0px 0px 1px',
		cursor: 'pointer',
		...CssSelectors.allDescendants(
			{
				border: `1px dashed ${brandSecondary}`,
				borderRadius: 3,
				boxSizing: 'border-box',
				fontSize: 14,
				padding: '1px 5px',
			},
			'span[data-placeholder="true"]'
		),
	},
	templateCardHeader: {
		display: `flex`,
		justifyContent: `space-between`,
	},
	templateCardHeaderTitle: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontSize: 14,
		fontWeight: 500,
		whiteSpace: 'nowrap',
	},
	templateSocialIndicator: {
		position: 'absolute',
		zIndex: 5,
		top: 0,
		right: 0,
	},
	templateSocialPopover: {
		borderBottomRightRadius: 0,
		boxSizing: 'border-box',
		color: label,
		fontSize: 12,
		lineHeight: '18px',
		marginLeft: 14,
		maxWidth: 240,
		padding: 4,
	},
	cardsContainer: {
		display: `flex`,
		flex: 1,
		flexDirection: `column`,
		gap: 8,
		minHeight: 0,
		overflow: `auto`,
		boxSizing: 'border-box',
		padding: 2,
	},
	emptyState: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		justifyContent: 'center',
		padding: THEME.spacing.xl,
		textAlign: 'center',
	},
	emptyStateFigure: {
		margin: 0,
	},
	emptyStateText: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	scopeHint: {
		color: THEME.colors.text.light,
		flexShrink: 0,
		fontSize: THEME.typography.fontSizes.xs,
		marginBottom: THEME.spacing.sm,
	},
	scopeToggle: {
		flexShrink: 0,
		marginBottom: THEME.spacing.sm,
		width: '100%',
	},
	trigger: {
		flexShrink: 0,
		marginBottom: 8,
		width: '100%',
	},
	templateCardButtonContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		marginTop: 8,
	},
});
